import script from "./AlertComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertComponent.vue?vue&type=script&setup=true&lang=js"

import "./AlertComponent.vue?vue&type=style&index=0&id=643b2036&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-643b2036"]])

export default __exports__